<template>
  <div class="kd-image-effects">
    <div class="kd-image-effects__list">
      <kd-image-effects-item
        label="Normal"
        id="normal"
        :isActive="!isEffectActive"
        :image-url="fullImageUrl(ACTIVE_IMAGE_URL)"
      ></kd-image-effects-item>
      <kd-image-effects-item
        label="Graustufen"
        id="grayscale"
        :isActive="grayscaleActive"
        :image-url="fullImageUrl(ACTIVE_IMAGE_URL)"
      ></kd-image-effects-item>
      <kd-image-effects-item
        label="Sepia"
        id="sepia"
        :isActive="sepiaActive"
        :image-url="fullImageUrl(ACTIVE_IMAGE_URL)"
      ></kd-image-effects-item>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import {
  ACTIVE_IMAGE_URL,
} from '@/store/getter-types';

import {
  ACTIVATE_EFFECT_FOR_ACTIVE_LAYER,
  DEACTIVATE_EFFECTS_FOR_ACTIVE_LAYER,
} from '@/store/mutation-types';

import KdImageEffectsItem from '@/components/KdImageEffectsItem.vue';

export default {
  props: {
    grayscaleActive: Boolean,
    sepiaActive: Boolean,
  },
  computed: {
    ...mapGetters([
      ACTIVE_IMAGE_URL,
    ]),
    isEffectActive() {
      return this.grayscaleActive || this.grayscaleActive;
    },
  },
  methods: {
    ...mapMutations([
      ACTIVATE_EFFECT_FOR_ACTIVE_LAYER,
      DEACTIVATE_EFFECTS_FOR_ACTIVE_LAYER,
    ]),
    fullImageUrl(imageUrl) {
      if (imageUrl) {
        // -> xyz.hach.de/uploads/1234.svg / localhost:3000/uploads/1234.svg
        return process.env.VUE_APP_IMAGE_SERVER + imageUrl;
      }
      return '';
    },
    deactivateEffects() {
      this.DEACTIVATE_EFFECTS_FOR_ACTIVE_LAYER();
    },
    activateEffect(id) {
      this.ACTIVATE_EFFECT_FOR_ACTIVE_LAYER(id);
    },
  },
  components: {
    KdImageEffectsItem,
  },
};
</script>

<style lang="scss">
.kd-image-effects__list {
  display: flex;
  justify-content: space-between;
}
</style>
